'use strict';

var React = require('react');
var withStyles = require('../../../../DesignSystem/Styles/withStyles.js');
var IconButton = require('../../../../DesignSystem/Inputs/Buttons/IconButton.js');
var Tooltip = require('../../../../DesignSystem/DataDisplay/Tooltips/Tooltip.js');
var Cancel = require('../../../../IconsAndImages/Icons/Cancel.js');
var AttachmentImage = require('../../../../IconsAndImages/Images/AttachmentImage.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    container: {
      '&:hover $action': {
        display: 'block'
      },
      height: '100%',
      width: '100%'
    },
    image: {
      backgroundSize: 'cover',
      height: '100%'
    },
    action: {
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'none'
    },
    cancelIcon: {
      '&:hover': {
        color: theme.palette.error.main
      }
    }
  };
};

var Attachment = function Attachment(_ref) {
  var image = _ref.image,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      classes = _ref.classes;

  var renderImage = function renderImage() {
    if (image) {
      return React__default["default"].createElement("div", {
        className: classes.image,
        style: {
          backgroundImage: "url(".concat(image, ")")
        },
        onClick: onClick
      });
    }

    return React__default["default"].createElement("div", {
      onClick: onClick
    }, React__default["default"].createElement(AttachmentImage, null));
  };

  return React__default["default"].createElement("div", {
    className: classes.container
  }, renderImage(), React__default["default"].createElement("div", {
    className: classes.action,
    onClick: onRemove
  }, React__default["default"].createElement(Tooltip, {
    title: "Remove attachment"
  }, React__default["default"].createElement(IconButton, {
    className: classes.cancelIcon
  }, React__default["default"].createElement(Cancel, null)))));
};

Attachment.defaultProps = {
  image: '',
  onClick: function onClick() {},
  onRemove: function onRemove() {}
};
var Attachment$1 = withStyles["default"](styles)(Attachment);

module.exports = Attachment$1;
